{
  "familyId": "GET-BREUK-MIN",
  "questions": [
    {
      "id": "GET-BREUK-MIN-001",
      "familyId": "GET-BREUK-MIN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_ong",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{5}{6}$ - $\\frac{2}{6}$ =",
      "context": null,
      "options": ["$\\frac{3}{6}$", "$\\frac{3}{12}$", "$\\frac{7}{6}$", "$\\frac{5}{6}$"],
      "correctAnswer": 0,
      "conceptId": "subtract_like_fractions_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.7,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 5, "denominator": 6, "label": "5/6"},
              {"numerator": 2, "denominator": 6, "label": "2/6"}
            ],
            "operator": "-",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 3,
            "denominator": 6,
            "label": "5/6 - 2/6 = 3/6",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is $\\frac{3}{6}$. Bij gelijknamige breuken trek je de tellers af: 5 - 2 = 3. De noemer blijft hetzelfde: 6. Dus $\\frac{5}{6}$ - $\\frac{2}{6}$ = $\\frac{3}{6}$.",
        "distractorExplanations": {
          "0": "Goed! Trek de tellers af: 5 - 2 = 3, noemer blijft 6. Dus $\\frac{5}{6}$ - $\\frac{2}{6}$ = $\\frac{3}{6}$.",
          "1": "$\\frac{3}{12}$ is fout. Je hebt de noemers ook opgeteld (6 + 6 = 12). Dat mag niet. Bij gelijknamige breuken blijft de noemer hetzelfde: $\\frac{5}{6}$ - $\\frac{2}{6}$ = $\\frac{3}{6}$.",
          "2": "$\\frac{7}{6}$ is fout. Je hebt de tellers opgeteld (5 + 2 = 7) in plaats van afgetrokken. Trek af: 5 - 2 = 3, dus $\\frac{5}{6}$ - $\\frac{2}{6}$ = $\\frac{3}{6}$.",
          "3": "$\\frac{5}{6}$ is de eerste breuk zelf, niet het antwoord. Je hebt de tweede breuk niet afgetrokken. Trek af: 5 - 2 = 3, dus $\\frac{5}{6}$ - $\\frac{2}{6}$ = $\\frac{3}{6}$."
        }
      }
    },
    {
      "id": "GET-BREUK-MIN-002",
      "familyId": "GET-BREUK-MIN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_ong",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{7}{8}$ - $\\frac{3}{8}$ =",
      "context": null,
      "options": ["$\\frac{4}{8}$", "$\\frac{4}{16}$", "$\\frac{10}{8}$", "$\\frac{1}{2}$"],
      "correctAnswer": 0,
      "conceptId": "subtract_like_fractions_eighths",
      "variantIndex": 2,
      "citoDifficulty": 0.4,
      "citoDiscrimination": 0.68,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 7, "denominator": 8, "label": "7/8"},
              {"numerator": 3, "denominator": 8, "label": "3/8"}
            ],
            "operator": "-",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 4,
            "denominator": 8,
            "label": "7/8 - 3/8 = 4/8",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is $\\frac{4}{8}$. Trek de tellers af: 7 - 3 = 4. De noemer blijft 8. Dus $\\frac{7}{8}$ - $\\frac{3}{8}$ = $\\frac{4}{8}$ (= $\\frac{1}{2}$).",
        "distractorExplanations": {
          "0": "Goed! Trek de tellers af: 7 - 3 = 4, noemer blijft 8. Dus $\\frac{7}{8}$ - $\\frac{3}{8}$ = $\\frac{4}{8}$.",
          "1": "$\\frac{4}{16}$ is fout. Je hebt de noemers opgeteld (8 + 8 = 16). Dat mag niet bij aftrekken. De noemer blijft 8: $\\frac{7}{8}$ - $\\frac{3}{8}$ = $\\frac{4}{8}$.",
          "2": "$\\frac{10}{8}$ is fout. Je hebt de tellers opgeteld (7 + 3 = 10) in plaats van afgetrokken. Trek af: 7 - 3 = 4, dus $\\frac{7}{8}$ - $\\frac{3}{8}$ = $\\frac{4}{8}$.",
          "3": "$\\frac{1}{2}$ is wel gelijk aan $\\frac{4}{8}$ (vereenvoudigd), maar het gevraagde antwoord is $\\frac{4}{8}$. $\\frac{7}{8}$ - $\\frac{3}{8}$ = $\\frac{4}{8}$."
        }
      }
    },
    {
      "id": "GET-BREUK-MIN-003",
      "familyId": "GET-BREUK-MIN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_ong",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{1}{2}$ - $\\frac{1}{4}$ =",
      "context": null,
      "options": ["$\\frac{1}{4}$", "$\\frac{0}{2}$", "$\\frac{2}{6}$", "$\\frac{1}{8}$"],
      "correctAnswer": 0,
      "conceptId": "subtract_unlike_fractions_basic",
      "variantIndex": 3,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.72,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 1, "denominator": 2, "label": "1/2"},
              {"numerator": 1, "denominator": 4, "label": "1/4"}
            ],
            "operator": "-",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 1,
            "denominator": 4,
            "label": "1/2 = 2/4, dan 2/4 - 1/4 = 1/4",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is $\\frac{1}{4}$. De noemers zijn ongelijk (2 en 4). Maak ze gelijk: $\\frac{1}{2}$ = $\\frac{2}{4}$. Dan: $\\frac{2}{4}$ - $\\frac{1}{4}$ = $\\frac{1}{4}$.",
        "distractorExplanations": {
          "0": "Goed! $\\frac{1}{2}$ = $\\frac{2}{4}$, dan $\\frac{2}{4}$ - $\\frac{1}{4}$ = $\\frac{1}{4}$.",
          "1": "$\\frac{0}{2}$ is fout. Je hebt 1 - 1 = 0 berekend maar de noemer 2 gehouden. De noemers zijn ongelijk: maak ze eerst gelijk. $\\frac{1}{2}$ = $\\frac{2}{4}$, dan $\\frac{2}{4}$ - $\\frac{1}{4}$ = $\\frac{1}{4}$.",
          "2": "$\\frac{2}{6}$ is fout. Je hebt de noemers opgeteld (2 + 4 = 6). Dat mag niet. Maak de noemers gelijk: $\\frac{1}{2}$ = $\\frac{2}{4}$, dan $\\frac{2}{4}$ - $\\frac{1}{4}$ = $\\frac{1}{4}$.",
          "3": "$\\frac{1}{8}$ is fout. Je hebt misschien tellers en noemers apart vermenigvuldigd. Maak de noemers gelijk: $\\frac{1}{2}$ = $\\frac{2}{4}$, dan $\\frac{2}{4}$ - $\\frac{1}{4}$ = $\\frac{1}{4}$."
        }
      }
    },
    {
      "id": "GET-BREUK-MIN-004",
      "familyId": "GET-BREUK-MIN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_ong",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{2}{3}$ - $\\frac{1}{6}$ =",
      "context": null,
      "options": ["$\\frac{3}{6}$", "$\\frac{1}{3}$", "$\\frac{1}{9}$", "$\\frac{2}{6}$"],
      "correctAnswer": 0,
      "conceptId": "subtract_unlike_fractions_thirds",
      "variantIndex": 4,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.75,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 2, "denominator": 3, "label": "2/3"},
              {"numerator": 1, "denominator": 6, "label": "1/6"}
            ],
            "operator": "-",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 3,
            "denominator": 6,
            "label": "2/3 = 4/6, dan 4/6 - 1/6 = 3/6",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is $\\frac{3}{6}$. De noemers zijn ongelijk (3 en 6). Maak ze gelijk: $\\frac{2}{3}$ = $\\frac{4}{6}$. Dan: $\\frac{4}{6}$ - $\\frac{1}{6}$ = $\\frac{3}{6}$.",
        "distractorExplanations": {
          "0": "Goed! $\\frac{2}{3}$ = $\\frac{4}{6}$, dan $\\frac{4}{6}$ - $\\frac{1}{6}$ = $\\frac{3}{6}$.",
          "1": "$\\frac{1}{3}$ is fout. Je hebt misschien $\\frac{2}{3}$ - $\\frac{1}{3}$ = $\\frac{1}{3}$ gerekend, maar de tweede breuk is $\\frac{1}{6}$, niet $\\frac{1}{3}$. Maak de noemers gelijk: $\\frac{2}{3}$ = $\\frac{4}{6}$, dan $\\frac{4}{6}$ - $\\frac{1}{6}$ = $\\frac{3}{6}$.",
          "2": "$\\frac{1}{9}$ is fout. Je hebt misschien tellers en noemers apart afgetrokken (2-1=1, 3+6=9). Dat mag niet. Maak de noemers gelijk: $\\frac{2}{3}$ = $\\frac{4}{6}$, dan $\\frac{4}{6}$ - $\\frac{1}{6}$ = $\\frac{3}{6}$.",
          "3": "$\\frac{2}{6}$ is fout. Je hebt $\\frac{2}{3}$ omgezet naar $\\frac{2}{6}$ (noemer verdubbeld maar teller niet). Als je de noemer verdubbelt, moet je de teller ook verdubbelen: $\\frac{2}{3}$ = $\\frac{4}{6}$, dan $\\frac{4}{6}$ - $\\frac{1}{6}$ = $\\frac{3}{6}$."
        }
      }
    }
  ]
}
